"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Raleway', sans-serif;\n  font-size: 14px;\n  color: #5b5b5b;\n\n  &.pui-typography--variant-h1 {\n    font-size: 26px;\n    font-weight: bold;\n    margin: 12px 0px;\n  }\n\n  &.pui-typography--variant-h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 12px 0px;\n  }\n\n  &.pui-typography--variant-h3 {\n    font-size: 22px;\n    font-weight: bold;\n    margin: 12px 0px;\n  }\n\n  &.pui-typography--variant-h4 {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 12px 0px;\n  }\n\n  &.pui-typography--variant-h5 {\n    font-size: 14px;\n    font-weight: bold;\n    margin: 12px 0px;\n  }\n\n  &.pui-typography--variant-p {\n    font-size: 14px;\n    font-weight: normal;\n    display: block;\n  }\n\n  &.pui-typography--variant-span {\n    font-size: 14px;\n    font-weight: normal;\n    display: inline;\n  }\n\n  &.pui-typography--variant-link {\n    font-size: 14px;\n    font-weight: normal;\n    text-decoration: underline;\n    color: #0084EE;\n    cursor: pointer;\n    display: inline;\n    background: none;\n    border: none;\n    outline: none;\n\n    &:hover {\n      color: #004f8f;\n    }\n  }\n\n  &.pui-typography--bold {\n    font-weight: bold;\n  }\n\n  &.pui-typography--italic {\n    font-style: italic;\n  }\n\n  &.pui-typography--lowercase {\n    text-transform: lowercase;\n  }\n\n  &.pui-typography--uppercase {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTypography = _styledComponents["default"].span(_templateObject());

var colorStyles = {
  'inherit': 'inherit',
  'default': '#5b5b5b'
};

var Typography = function Typography(_ref) {
  var className = _ref.className,
      as = _ref.as,
      variant = _ref.variant,
      color = _ref.color,
      children = _ref.children,
      uppercase = _ref.uppercase,
      lowercase = _ref.lowercase,
      bold = _ref.bold,
      italic = _ref.italic,
      props = _objectWithoutProperties(_ref, ["className", "as", "variant", "color", "children", "uppercase", "lowercase", "bold", "italic"]);

  return function (color) {
    var theme = (0, _useTheme["default"])();
    var elementType = as ? as : variant;
    var color = colorStyles[color] ? colorStyles[color] : color;

    if (theme.palette[color]) {
      color = theme.palette[color][500];
    }

    var styledClassName = (0, _clsx["default"])(className, 'pui-typography', "pui-typography--variant-".concat(variant), {
      'pui-typography--uppercase': uppercase,
      'pui-typography--lowercase': lowercase,
      'pui-typography--bold': bold,
      'pui-typography--italic': italic
    });
    var elementProps = {
      as: elementType,
      className: styledClassName
    };

    if (color && color !== 'default' && variant !== 'link') {
      elementProps.style = _objectSpread(_objectSpread({}, props.style), {}, {
        color: color
      });
    }

    return /*#__PURE__*/_react["default"].createElement(StyledTypography, _extends({}, props, elementProps), children);
  }(color);
};

Typography.propTypes = {
  /**
   * Element to mount h1, h2, h3, h4, h5, h6, p, span, link
   */
  as: _propTypes["default"].elementType,

  /**
   * Text style
   */
  variant: _propTypes["default"].elementType,

  /**
   * Text color
   */
  color: _propTypes["default"].string,
  uppercase: _propTypes["default"].bool,
  lowercase: _propTypes["default"].bool,
  bold: _propTypes["default"].bool,
  italic: _propTypes["default"].bool
};
Typography.defaultProps = {
  variant: 'h1',
  color: 'default',
  uppercase: false,
  lowercase: false,
  bold: false,
  italic: false
};
var _default = Typography;
exports["default"] = _default;